export default __webpack_public_path__ + "static/media/Alelo.2aaba6db.svg";